/*
 * VIP confirmation gate + orphan-add-on guard.
 *
 * Loaded once from layout/theme.liquid (NOT inline in the cart-summary section).
 * The cart summary is frequently injected via the Section Rendering API (adding a
 * VIP from a custom product page, opening the drawer, updating quantities, removing
 * a line). Inline <script> tags inside injected HTML do NOT execute, so an inline
 * gate never re-wires and the button state goes stale until a full refresh. Loading
 * here + delegated listeners means it always works, however the cart re-renders.
 *
 * Two rules, both must pass for checkout to unlock:
 *   1. the "I confirm…" terms box is ticked, AND
 *   2. no ORPHAN add-ons — every add-on (Ticket = "Video…"/"Photo…") must have a
 *      VIP Package for the SAME date in the cart. (Stops "delete the VIP in cart,
 *      keep the add-ons, check out with add-ons only".)
 */
(function () {
  if (window.__VIP_CART_GATE__) return;
  window.__VIP_CART_GATE__ = true;

  var SCOPES = ['cart-drawer-component', '.cart-drawer', 'cart-items-component', 'main-cart', 'form[action*="/cart"]', '.cart'];
  var orphanDates = []; // dates that have add-ons but no VIP Package in the cart

  function findScope(el) {
    for (var i = 0; i < SCOPES.length; i++) { var s = el.closest(SCOPES[i]); if (s) return s; }
    return document;
  }
  function lock(b) { if (!b) return; b.setAttribute('disabled', 'disabled'); b.setAttribute('aria-disabled', 'true'); }
  function unlock(b) { if (!b) return; if (b.hasAttribute('data-cart-empty')) return; b.removeAttribute('disabled'); b.setAttribute('aria-disabled', 'false'); }
  function setAccelerated(scope, enabled) { var a = scope.querySelector('[data-vip-gated-accelerated]'); if (a) a.setAttribute('aria-hidden', enabled ? 'false' : 'true'); }

  // --- classify a cart line into { date, ticket } from its option values ---
  function classify(item) {
    var vals = (item.options_with_values || []).map(function (o) { return o.value; });
    if (!vals.length && item.variant_options) vals = item.variant_options;
    var date = null, ticket = null;
    for (var i = 0; i < vals.length; i++) {
      var v = String(vals[i] || '');
      if (/^\d{2}\/\d{2}/.test(v)) date = v; else ticket = v;
    }
    return { date: date, ticket: ticket };
  }
  // An item is an ADD-ON if its ticket name starts with Video/Photo. ANYTHING ELSE
  // counts as a base package for that date.
  //
  // Do NOT go back to name-matching the base with /VIP/. That was the old rule and
  // it silently broke ARTMS: its base is labelled "Standard Package", not "VIP
  // Package", so no base was ever detected, every add-on looked like an orphan, and
  // a perfectly valid ARTMS cart (Standard Package + Video Selfie, same date) could
  // never reach checkout. Base names vary per tour — "VIP Experience", "Standard
  // Package", whatever a client asks for next — so the base must be defined
  // structurally (not-an-add-on), never by matching a word in the label.
  // Found + fixed 2026-08-27, one day before the ARTMS on-sale.
  // Add-on naming is NOT consistent between tours, so this must not be anchored:
  //   ARTMS  -> "Video Selfie – HeeJin" / "Photo Selfie – HeeJin"   (starts with the word)
  //   ZZ test-> "Selfie Video – Aki"    / "1:1 Photo – Aki"         (word is in the MIDDLE)
  // The old anchored /^(Video|Photo)/ silently treated every ZZ add-on as a BASE, which
  // made the orphan guard completely inert on the very product the client uses to test it.
  // Matching video/photo as a WORD anywhere covers both conventions. Validated against
  // every ticket value in the live catalogue (2026-08-27): all 8 real add-ons match, and
  // every base — "VIP Experience", "VIP Package", "VIP", "Standard Package", "Meet & Greet",
  // "Left To Suffer VIP Experience", "Nathan Evans Europe VIP Experience" — does not.
  // ⛔ Re-run that catalogue check before adding a tour whose package names are unusual.
  function isAddonTicket(ticket) {
    return /\b(video|photo)\b/i.test(ticket) || /^(selfie|1:1)/i.test(ticket);
  }
  // STANDALONE products: sold on their own to customers who ALREADY hold a VIP from a
  // previous order (the ARTMS "1:4 Photo" buyer-only upsell, 2026-09-21). Their ticket
  // name contains "Photo", so isAddonTicket() would file them as add-ons and demand a
  // same-date base IN THIS CART — which is exactly the flow they exist to avoid. They
  // are neither base nor add-on: skip them entirely. Entitlement for these lives in the
  // product template (customer.orders check) + KOR, not here. Keyed on product HANDLE
  // so a future rename of the ticket label can't silently re-break checkout.
  var STANDALONE_HANDLE_RE = /^artms-1-4-photo/i;
  function isStandalone(item) { return STANDALONE_HANDLE_RE.test(String(item.handle || '')); }
  function computeOrphans(cart) {
    var base = {}, addon = {};
    (cart.items || []).forEach(function (it) {
      if (isStandalone(it)) return;
      var c = classify(it);
      if (!c.date || !c.ticket) return;
      if (isAddonTicket(c.ticket)) addon[c.date] = true;
      else base[c.date] = true;
    });
    return Object.keys(addon).filter(function (d) { return !base[d]; });
  }

  function applyAll() {
    var blocked = orphanDates.length > 0;
    document.querySelectorAll('[data-vip-orphan]').forEach(function (el) {
      if (blocked) {
        el.textContent = 'Add-ons for ' + orphanDates.join(', ') + ' need a VIP Package in your cart — add a VIP Package for '
          + (orphanDates.length > 1 ? 'those dates' : 'that date') + ', or remove the add-ons to check out.';
        el.hidden = false;
      } else {
        el.hidden = true;
      }
    });
    document.querySelectorAll('[data-vip-gate-checkbox]').forEach(syncGate);
  }

  function syncGate(checkbox) {
    if (!checkbox) return;
    var scope = findScope(checkbox);
    var button = scope.querySelector('.cart__checkout-button[data-vip-gated]');
    var ok = checkbox.checked && orphanDates.length === 0;
    if (ok) unlock(button); else lock(button);
    setAccelerated(scope, ok);
  }
  window.__VIP_GATE_SYNC_ALL__ = applyAll;

  var fetching = false;
  function refreshCart() {
    if (fetching) return; fetching = true;
    fetch('/cart.js', { headers: { 'Accept': 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) { fetching = false; orphanDates = computeOrphans(cart); applyAll(); })
      .catch(function () { fetching = false; applyAll(); });
  }

  // 1) delegated change on the terms checkbox.
  //     CAPTURE phase (the `true`) is REQUIRED, not stylistic. The cart DRAWER
  //     (cart-drawer-component > dialog) stops `change` from propagating, so a
  //     bubble-phase listener on document never fires there: ticking the box did
  //     nothing and CHECK OUT stayed locked, while the /cart page worked fine.
  //     Capture runs at document BEFORE the event reaches the target, so nothing
  //     downstream can stopPropagation() it away. Fixed 2026-08-27.
  document.addEventListener('change', function (e) {
    var cb = e.target && e.target.closest && e.target.closest('[data-vip-gate-checkbox]');
    if (cb) syncGate(cb);
  }, true);

  // 2) block clicks on a locked button; flash whichever reason is active
  document.addEventListener('click', function (e) {
    var btn = e.target && e.target.closest && e.target.closest('.cart__checkout-button[data-vip-gated]');
    if (!btn) return;
    if (btn.getAttribute('aria-disabled') === 'true') {
      e.preventDefault();
      e.stopPropagation();
      var scope = findScope(btn);
      var flash = (orphanDates.length > 0 ? scope.querySelector('[data-vip-orphan]') : null) || scope.querySelector('[data-vip-gate]');
      if (flash) {
        flash.style.transition = 'box-shadow 0.2s ease';
        flash.style.boxShadow = '0 0 0 3px rgba(255, 26, 26, 0.4)';
        setTimeout(function () { flash.style.boxShadow = ''; }, 600);
      }
    }
  }, true);

  // 3) re-check the cart on any cart re-render (add / remove / qty / drawer open)
  ['cart:refresh', 'cart:update', 'cart:updated', 'cart:change', 'shopify:cart:update', 'cart-drawer:open']
    .forEach(function (ev) { document.addEventListener(ev, refreshCart); });

  // 4) observe injected cart summaries / line-item changes that fire no event
  var pending = false;
  function schedule() { if (pending) return; pending = true; requestAnimationFrame(function () { pending = false; refreshCart(); }); }
  function startObserver() {
    if (!document.body) return;
    new MutationObserver(function (muts) {
      for (var i = 0; i < muts.length; i++) {
        var added = muts[i].addedNodes;
        for (var j = 0; j < added.length; j++) {
          var n = added[j];
          if (n.nodeType !== 1) continue;
          if ((n.matches && n.matches('[data-vip-gate-checkbox], [data-vip-gate], [data-vip-orphan], .cart__checkout-button, .cart-items__table-row')) ||
              (n.querySelector && n.querySelector('[data-vip-gate-checkbox], .cart-items__table-row'))) {
            schedule();
            return;
          }
        }
      }
    }).observe(document.body, { childList: true, subtree: true });
  }

  // 5) initial + lifecycle
  function init() { startObserver(); refreshCart(); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
  window.addEventListener('pageshow', refreshCart); // bfcache restore
})();
